import { useMemo } from "react";
import { graphql } from "gatsby";
import { SeasonPassPurchase, isArray, SimplifyGatsbyQuery, Product } from "@parksandresorts/core";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const SeasonPassPurchaseBlock = ({
  contentful_id,
  digitalProducts,
  physicalProducts,
  reactivateProducts,
  description,
  reactivateDescription,
  reactivateInstruction,
  selectPassTypeInstruction,
  labelsOverride,
}: SimplifyGatsbyQuery<Queries.SeasonPassPurchaseBlockFragment> & {
  // We fake these properties to make TypeScript happy.
  digitalProducts: Array<Product>;
  physicalProducts: Array<Product>;
  reactivateProducts: Array<Product>;
}) => {
  const mappedLabels = useMemo(() => {
    if (!labelsOverride || !isArray(labelsOverride.list)) {
      return {};
    }

    return labelsOverride.list.reduce<Record<string, string>>((labels, item) => {
      if (item.key && item.value) {
        labels[item.key] = item.value;
      }
      return labels;
    }, {});
  }, [labelsOverride]);

  const texts = {
    description: description,
    reactivateDescription: reactivateDescription,
    reactivateInstruction: reactivateInstruction,
    selectPassTypeInstruction: selectPassTypeInstruction,
  };

  return (
    <section className="block block--no-margin" data-contentful-id={contentful_id}>
      <SeasonPassPurchase
        digitalProducts={digitalProducts}
        physicalProducts={physicalProducts}
        reactivateProducts={reactivateProducts}
        texts={texts}
        labelsOverride={mappedLabels}
        useShopServiceCart={SiteConfigurationStore.siteConfiguration.useNewCheckout}
      />
    </section>
  );
};

export default SeasonPassPurchaseBlock;

export const fragmentSeasonPassPurchaseBlock = graphql`
  fragment SeasonPassPurchaseBlock on ContentfulSeasonPassPurchaseBlock {
    contentful_id
    id
    digitalProducts {
      ...ProductBlockStore
    }
    physicalProducts {
      ...ProductBlockStore
    }
    reactivateProducts {
      ...ProductBlockStore
    }
    description {
      raw
      references {
        __typename
        ...Link
        ...ContentPageLink
      }
    }
    reactivateDescription {
      raw
    }
    reactivateInstruction {
      raw
    }
    selectPassTypeInstruction {
      raw
    }
    labelsOverride {
      list {
        key
        value
      }
    }
  }
`;
